import MindsetsJsSDK, {LoadingAction} from "mindsets-js-sdk";

export const LoadRubricPDFAction = (challenge_code, practice_identifier, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'One moment... we\'re building the rubric for you!')))
        .then(() => MindsetsJsSDK().API.get(`challenge_codes/${challenge_code}/practices/${practice_identifier}/rubric`, options));
};
